import React, { Component } from 'react';
import './styles.css';
import Input from 'components/Input';
import route, { NavLink } from 'route';
import PropTypes from 'prop-types';
import logo from '../../assets/images/TIM_Logo_2016.png';

class Form extends Component {
	constructor(props) {
		super(props);

		this.state = {
			fields: {}
		};

		props.fields.forEach(field => {
			this.state.fields[ field.key ] = { value: '' };
		});
	}

	getField = key => {
		let currentField = undefined;

		this.props.fields.forEach(field => {
			if (field.key === key) {
				currentField = field;
			}
		});

		return currentField;
	};

	onChange = (key, value) => {
		let validRules = true;
		const currentField = this.getField(key);

		if (currentField.rules && value.length > 0) {
			currentField.rules.forEach(rule => {
				if (rule === 'numbers') {
					if (!value.match(/^[0-9]+$/)) {
						validRules = false;
					}
				} else if (rule === 'phone') {
					if (!value.match(/^[0-9+]+$/)) {
						validRules = false;
					}
				}
			});
		}

		if (validRules) {
			this.state.fields[ key ] = { value, error: undefined };
			this.setState({
				fields: this.state.fields
			});
		}
	};

	validateForm = () => {
		let validate = true;

		let fields = this.state.fields;
		Object.keys(this.state.fields).forEach(key => {
			const originalfield = this.getField(key);

			if (!fields[ key ].value && originalfield.errorRequired) {
				validate = false;
				fields[ key ].error = originalfield.errorRequired;
			}
		});

		this.setState({ fields });

		return validate;
	};

	render() {
		const { onFinish } = this.props;
		return (
			<div className="form" {...this.props}>
				<div className="form-fields">
					<img src={logo} alt="logo" />
					<h3>
						Inserisci i tuoi dati, sarai contattato entro 48 ore da un
						consulente di TIM che ti aiuterà <strong>gratuitamente</strong> e
						<strong> senza impegno</strong> a scegliere la tariffa migliore
						<strong> per i nuovi clienti</strong>.
					</h3>
					<div id="separator" style={{ height: '2vh' }} />
					{this.props.fields &&
						this.props.fields.map((field, index) => (
							<Input
								key={index}
								placeholder={field.hint}
								value={this.state.fields[ field.key ].value}
								error={this.state.fields[ field.key ].error}
								onChange={e => {
									this.onChange(field.key, e.target.value);
								}}
							/>
						))}
					<NavLink id="navlink" target="_blank" exact to={route('privacy')}>
						Leggi l'informativa sulla privacy di TIM
					</NavLink>
					<p className="privacy-paragraph">
						Inserendo il mio numero di telefono, autorizzo TIM a contattarmi per
						ricevere assistenza e informazioni sull'acquisto delle offerte TIM.
						Dichiaro di aver preso visione dell'{' '}
						<NavLink id="navlink" target="_blank" exact to={route('privacy')}>
							informativa privacy
						</NavLink>{' '}
						di essere l'intestatario del numero fornito e di essere a conoscenza
						delle sanzioni previste dalla vigente normativa in caso di rilascio
						di dichiarazioni mendaci.
					</p>
					<div className="form-bottom">
						<button
							onClick={() => {
								let sanitizedFields = {
									...this.state.fields
								};

								Object.keys(sanitizedFields).forEach(
									key =>
										sanitizedFields[ key ].value === '' &&
										delete sanitizedFields[ key ]
								);

								Object.keys(sanitizedFields).forEach(key => {
									sanitizedFields[ key ] = sanitizedFields[ key ].value;
								});

								onFinish && onFinish(sanitizedFields);
							}}
						>
							Contattami
						</button>
					</div>
				</div>
			</div>
		);
	}
}

Form.propTypes = {
	onFinish: PropTypes.func.isRequired
};

export default Form;



// WEBPACK FOOTER //
// ./src/components/Form/index.js